import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, CssBaseline, Button } from '@mui/material';

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const message = location.state?.message || 'An error occurred. Please try again.';

  return (
    <Container component="main" maxWidth="sm" style={{ height: '52vh', display: 'flex', alignItems: 'center' }}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography component="h1" variant="h5">
          Error
        </Typography>
        <Typography sx={{ mt: 2 }}>
          {message}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={() => navigate('/')}
        >
          Go Back
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorPage;
